import abi from "./ABI.json";

export const contractAddress = "0xA3813882EFBf02f3bDF3eb5adDAe397161F7D526";
export const CONTRACT_ABI = abi.abi;